import React, { createContext, PropsWithChildren, useContext } from 'react';

import { useFetchBillingInfoQuery } from '../../redux/api/appMarket-api-slice';
import { useAppMode } from '../../hooks/useAppMode';
import { MerchantBillingInformation } from '../../models/app';
import { AppMode } from '../../models/enums';
import { Region } from '../../utils/i18n/region';
import { useAppContext } from '../../hooks/useAppContext';

const defaultValues: MerchantBillingInformation = {
    accountStatus: '',
    seasonal: true,
    appMarketConfig: {
       allowPaidAppInstalls: true,
       allowPaidAppUpgrades: true
	},
	billingInfo: {
       planBillable: true,
       appBillable: true,
       planExportable: true,
       appExportable: true,
       termsAccepted: true
	},
    hardware: true
};

export const BillingContext = createContext<MerchantBillingInformation>(defaultValues);
BillingContext.displayName = 'BillingContext';

export const useBillingInfo = () => useContext(BillingContext);

export const BillingContextProvider : React.FC<PropsWithChildren<{}>> = (props : PropsWithChildren<{}>) : JSX.Element => {
  const { children } = props;
  const appMode = useAppMode();
  const merchantId = useAppContext()?.id || '';

  /* Skipping the call for LA as this is not available at the moment on this particular region */
  const { data: billingInformation } = useFetchBillingInfoQuery(undefined,{skip: !merchantId || appMode === AppMode.Public || Region.current === Region.LA});
  let value = billingInformation || defaultValues

  return (
    <BillingContext.Provider value={value}>
      {children}
    </BillingContext.Provider>
  );
};
